import { Component, Inject } from '@angular/core';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISelection } from 'pbc.types';

import { IProjektArtsQueryShapes, ProjektArtsQueryFilterConfig } from 'fa-kt.types';
import { ProjektArtsService } from '../service';

@Component({
  selector: 'fa-kt-projekt-arts-filter',
  templateUrl: './projekt-arts-filter.component.html',
  styleUrls: ['./projekt-arts-filter.component.css'],
})
export class ProjektArtsFilterComponent {
  readonly subscriptions: Subscription[] = [];

  ProjektArtsFilterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public projektArts: ProjektArtsService,
  ) {
    this.ProjektArtsFilterConfig = ProjektArtsQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push(
      this.projektArts.shapes$.subscribe((shapes: IProjektArtsQueryShapes | undefined) => {
        if (!shapes) {
          return;
        }
        Object.entries(shapes)
          .filter(([key]) => key !== 'id' && (shapes as any)[key])
          .forEach(([key]) => this.shape(key, (shapes as any)[key]));
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.ProjektArtsFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.ProjektArtsFilterConfig[index].selections = shapes;
  }
}
